import { render, staticRenderFns } from "./LogoCompany.vue?vue&type=template&id=45190bbf&lang=pug&"
import script from "./LogoCompany.vue?vue&type=script&lang=ts&"
export * from "./LogoCompany.vue?vue&type=script&lang=ts&"
import style0 from "./LogoCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports